var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',[_c('h3',[_c('span',{staticClass:"prefix_dono"},[_vm._v(" Monthly Top Donator: ")]),_c('span',{staticClass:"dono"},[_vm._v(" "+_vm._s(this.top_dono)+" ")])])]):_c('div',[_vm._v(" Loading.... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }